import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon-component.html',
  styleUrls: ['./svg-icon-component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SvgIconComponent implements OnInit {

  @Input() svgTypeIcon: string;

  constructor() {
  }


  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/modules/delegation/svg-icon/svg-icon-component.ts